import {useEffect, useRef, useState} from "react";
import {Redirect, Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import aceLogo from "../assets/img/brand/ace-logo.png";
import progressLogo from "../assets/img/brand/logo-progress.png";
import routes from "../routes";
import {doc, getDoc} from "firebase/firestore";
import {getDb} from "../util/Constants";
import Swal from "sweetalert2";

const Admin = (props) => {

    const [sheetsLoaded, setSheetsLoaded] = useState(false);
    const [isValidUser, setIsValidUser] = useState(true);
    const mainContent = useRef(null);
    const location = useLocation();
    const history = useHistory();
    const {eventId} = useParams();


    useEffect(() => {
        console.log(eventId);
        const fullRoute = props.location.pathname;
        const lastIndex = fullRoute.lastIndexOf('/');
        const result = fullRoute.substring(lastIndex + 1);
        console.log(result);
        verifyEvent(result, props.signedInUser.uid).then(_isValidUser => {
            if (!_isValidUser && props.signedInUser.role !== "superAdmin") {
                document.body.classList.add('blur-background');
                Swal.fire({
                    icon: 'error',
                    title: 'Wrong Event',
                    text: 'You are trying to access wrong event',
                    confirmButtonText: 'Okay',
                    allowOutsideClick: false
                }).then(result => {
                    if (result.isConfirmed) {
                        history.push("/assessment/dashboard");
                        document.body.classList.remove('blur-background');
                    }
                })
            }
            console.log(_isValidUser);
            // setIsValidUser(_isValidUser);
        })
    }, [])

    // useEffect(async () => {
    //     await loadDocument(props.signedInUser.sheetId, "tabIndex");
    //     setSheetsLoaded(true);
    // }, []);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainContent.current.scrollTop = 0;
    }, [location]);

    const getRoutes = (routes) => {
        return routes.map((route, key) => {
            return (
                <Route
                    exact
                    key={key}
                    path={route.layout + route.path}
                    name={route.name}
                    render={renderProps => <route.component {...renderProps} signedInUser={props.signedInUser}
                                                            sheetsLoaded={sheetsLoaded}/>}
                />
            );
        });
    };
    const getBrandText = (path) => {

        const _routes = [...routes.common.filter((e) => e.name !== 'Assessments'), ...routes[props?.signedInUser?.role]]
        for (let i = 0; i < _routes.length; i++) {
            let pathType = ""
            if (_routes[i].path2) {
                pathType = _routes[i].path2
            } else {
                pathType = _routes[i].path
            }
            if (
                props.location.pathname.indexOf(_routes[i].layout + pathType) !==
                -1
            ) {
                return props.signedInUser.projectType === "progress" && _routes[i].name === "Assessor Board" ? "LeaderBoard 2" : _routes[i].name;
            }
        }
        return "";
    };

    const verifyEvent = async (_eventId, userId) => {
        console.log(_eventId);
        const docRef = doc(getDb(), "Events", _eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            return data.userId === userId;
        } else {
            return true;
        }
    }

    const filterRoutes = (routes) => {
        console.log(props.metadata);
        const role = props.signedInUser.role;
        const environment = props.metadata.environment;
        if (role === "superAdmin") {
            return routes.filter(route => route.environment === environment || route.environment === "common");
        } else {
            return routes;
        }
    }

    return (
        <>

            <Sidebar
                {...props}
                setRouteState={props.setRouteState}
                routes={[...routes.common, ...filterRoutes(routes[props?.signedInUser?.role])]}
                logo={{
                    // innerLink: "/admin/index",
                    imgSrc: props.metadata.environment === "progress" ? progressLogo : aceLogo,
                    imgAlt: "...",
                }}
            />


            <div className="main-content" ref={mainContent}>

                <AdminNavbar
                    setRouteState={props.setRouteState}
                    {...props}
                    brandText={getBrandText(props.location.pathname)}
                />

                <Switch>
                    {getRoutes([...routes.common, ...routes[props.signedInUser.role]])}

                    <Redirect from="*"
                              to={props.signedInUser.role === 'superAdmin' ? '/admin/accounts' : '/assessment/dashboard'}/>
                </Switch>
            </div>
        </>
    );
};

export default Admin;
